import React, { useEffect, useState } from 'react';
import { Route, Routes, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { researchosService } from '../../services/researchosService';
import PodiumCallsPanel from './PodiumCallsPanel';
import PodiumCallView from './PodiumCallView';
import PodiumReviewPanel from './PodiumReviewPanel';
import PodiumPeoplePanel from './PodiumPeoplePanel';
import PodiumPersonView from './PodiumPersonView';

const GOLD = 'rgb(var(--brand-gold-rgb))';

// Podium — management speaking from the front of the room (Chatter is the crowd). Calls, the review queue, people.
const TABS = [
  { id: 'calls', label: 'Calls' },
  { id: 'review', label: 'Review' },
  { id: 'people', label: 'People' },
];

function TabBtn({ active, onClick, children }) {
  return (
    <button onClick={onClick} className="px-3 py-1.5 text-xs uppercase tracking-[0.15em] rounded border transition-colors"
      style={active ? { color: GOLD, border: '1px solid ' + GOLD, fontWeight: 500 } : { color: 'inherit', border: '1px solid transparent', opacity: 0.7 }}>
      {children}
    </button>
  );
}

function Shell({ tab, setTab, children }) {
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-serif text-xl text-gray-900 dark:text-gray-100">Podium</h2>
          <p className="text-sm text-gray-500 dark:text-gray-400">Earnings and analyst calls: who said what, by voice and by cue. The mini listens; the platform keeps the record.</p>
        </div>
        <nav className="flex gap-2">{TABS.map(t => <TabBtn key={t.id} active={tab === t.id} onClick={() => setTab(t.id)}>{t.label}</TabBtn>)}</nav>
      </div>
      {children}
    </div>
  );
}

function CallRoute() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  return <PodiumCallView slug={slug} jumpTo={params.get('t')} onBack={() => navigate('/researchos/podium')}
    onPerson={key => navigate(`/researchos/podium/people/${key}`)}
    onReview={() => navigate('/researchos/podium?tab=review')} />;
}

function PersonRoute() {
  const { key } = useParams();
  const navigate = useNavigate();
  return <PodiumPersonView personKey={key} onBack={() => navigate(-1)}
    onOpenCall={(slug, at) => navigate(`/researchos/podium/calls/${slug}${at != null ? `?t=${Math.floor(at)}` : ''}`)} />;
}

export default function PodiumPage() {
  const [scope, setScope] = useState(null);
  const [params] = useSearchParams();
  const [tab, setTab] = useState(params.get('tab') || 'calls');
  const navigate = useNavigate();
  useEffect(() => {
    let alive = true;
    researchosService.getScope().then(r => { if (alive) setScope(r.data); }).catch(() => { if (alive) setScope({ is_admin: false }); });
    return () => { alive = false; };
  }, []);
  if (scope && !scope.is_admin) {
    return <p className="text-sm text-gray-500 dark:text-gray-400">Podium is an admin section for now: the transcripts, the review decisions and the people roster are visible to platform administrators only.</p>;
  }
  return (
    <Routes>
      <Route path="calls/:slug" element={<CallRoute />} />
      <Route path="people/:key" element={<PersonRoute />} />
      <Route path="*" element={
        <Shell tab={tab} setTab={setTab}>
          {tab === 'calls' && <PodiumCallsPanel onOpen={slug => navigate(`/researchos/podium/calls/${slug}`)} />}
          {tab === 'review' && <PodiumReviewPanel />}
          {tab === 'people' && <PodiumPeoplePanel onOpen={key => navigate(`/researchos/podium/people/${key}`)} />}
        </Shell>
      } />
    </Routes>
  );
}
